import * as Sentry from '@sentry/react';

/**
 * Hostname-based Sentry setup:
 * - hos.dev.vistracks.com (and local): development DSN
 * - hos.azuga.com: production DSN
 */
const hostname = window.location.hostname.toLowerCase();

const isHosDev =
  hostname === 'hos.dev.vistracks.com' ||
  hostname === 'localhost' ||
  hostname === '127.0.0.1';

const isHosProd = hostname === 'hos.azuga.com';

const sharedIntegrations = [
  Sentry.browserTracingIntegration(),
  Sentry.replayIntegration(),
];

if (isHosDev) {
  Sentry.init({
    dsn: 'https://6cff440ce360cc183e58eabc039103ac@sentry.dev.vistracks.com/9',
    environment: 'development',
    integrations: sharedIntegrations,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      'hos.dev.vistracks.com',
      /^\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
} else if (isHosProd) {
  Sentry.init({
    dsn: 'https://02d9474fa9b79f2b07d98d53ceb153b6@sentry.prod.vistracks.com/4',
    environment: 'production',
    integrations: sharedIntegrations,
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['hos.azuga.com', /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
